import script from "./PixsoButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PixsoButton.vue?vue&type=script&setup=true&lang=js"

import "./PixsoButton.vue?vue&type=style&index=0&id=821542ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-821542ce"]])

export default __exports__